<div class="results-container">
  <div class="columns is-multiline is-mobile is-gapless header-container">
    <div class="column is-12-mobile is-6-tablet">
      <div class="wizard-step-header">
        <h1 class="wizard-results-title">{{title}}</h1>
        <!-- <p *ngIf="!showTopNumberOfItemsMessage" class="wizard-step-subtitle">{{subtitle}}</p> -->
      </div>
    </div>
    <div class="column is-hidden-mobile is-6-tablet header-button-container">
      <!-- <div>
        <button mat-flat-button class="secondary" (click)="handleStartOverClick()">{{startOverButtonText}}</button>
      </div> -->
      <!-- <div *ngIf="showShareResultsButton">
        <button mat-flat-button class="primary header-share-results-button" (click)="handleShareResultsClick()">{{shareResultsButtonText}}</button>
      </div> -->
      <div *ngIf="showSaveResultsButton">
        <button mat-flat-button class="primary header-share-results-button" (click)="handleShowSaveResultsClick()">SAVE RESULTS</button>
      </div>
    </div>
  </div>
  <!-- results content -->
  <div class="columns is-multiline is-mobile is-gapless">
    <!-- info and filtering -->
    <div class="sidebar-wrapper column is-12-mobile is-3-tablet">
      <!-- <div class="is-hidden-mobile" *ngIf="showTopNumberOfItemsMessage">
        <h1 class="results-msg">{{topNumberOfItemsMessage}}</h1>
      </div> -->
      <div class="columns is-multiline is-mobile is-gapless">
        <!-- your selections -->
        <div class="column is-half-mobile is-full-tablet mobile-banner-column mobile-banner-left-column is-hidden-mobile">
          <app-selections></app-selections>
          <div class="spacer-small"></div>
          <div class="start-over">
            <button mat-flat-button class="secondary" (click)="handleStartOverClick()">{{startOverButtonText}}</button>
          </div>
        </div>
        <div class="column is-hidden-mobile">
          <div class="spacer-large"></div>
        </div>
        <!-- perfect for -->
        <!-- <div class="column is-half-mobile is-full-tablet mobile-banner-column mobile-banner-right-column">
          <app-ideal-use-case></app-ideal-use-case>
        </div> -->
        <!-- mobile filter button and messages -->
        <!-- tablet and desktop filters -->
        <div class="columns is-multiline is-gapless is-hidden-mobile">
          <div class="column is-full">
            <label class="info-header">{{filtersTitle}}</label>
            <div class="spacer-small"></div>
          </div>
          <!-- availability -->
          <div >
            <app-availability-filters #availabilityFilters (availabilityToFilterBy)="handleAvailabilityFilter($event)"></app-availability-filters>
          </div>
          <div class="column">
            <div class="spacer-medium"></div>
          </div>
          <!-- chromebook plus -->
          <div class="column is-full-tablet">
            <app-chromebook-plus-filters #chromebookPlusFilters (ChromebookPlusToFilterBy)="handleChromebookPlusFilter($event)"></app-chromebook-plus-filters>
          </div>
          <!-- form factors -->
          <div class="column is-full-tablet">
            <app-form-factors-filters #formFactorFilters (formFactorsToFilterBy)="handleFormFactorFilter($event)"></app-form-factors-filters>
          </div>
          <div class="column">
            <div class="spacer-medium"></div>
          </div>
          <!-- screen sizes -->
          <div class="column is-full-tablet">
            <app-screen-size-filters #screenSizeFilters (screenSizesToFilterBy)="handleScreenSizeFilter($event)"></app-screen-size-filters>
          </div>
          <div class="column">
            <div class="spacer-medium"></div>
          </div>
          <!-- brands -->
          <div class="column is-full-tablet">
            <app-brand-filters #brandFilters (brandsToFilterBy)="handleBrandsFilter($event)" (setInitialSelectedBrands)="setInitialSelectedBrands($event)"></app-brand-filters>
          </div>
          <div class="column">
            <div class="spacer-medium"></div>
          </div>
          <!-- features -->
          <div class="column is-full-tablet">
            <app-feature-filters #featureFilters (featuresToFilterBy)="handleFeatureFilter($event)"></app-feature-filters>
          </div>
          <div class="column">
            <div class="spacer-medium"></div>
          </div>
          <!-- os types -->
          <div class="column is-full-tablet">
            <app-os-type-filters #osTypeFilters [isEnterpriseWorkflow]="isEnterprisePrimaryUse" (osTypesToFilterBy)="handleOsTypeFilter($event)" (setInitialSelectedOsTypes)="setInitialSelectedOsTypes($event)"></app-os-type-filters>
          </div>
          <div class="column">
            <div class="spacer-medium"></div>
            <div class="spacer-medium"></div>
          </div>
          <!-- AUE link desktop -->
          <div class="column is-full-tablet" *ngIf="showAUELink">
            <app-aue-link></app-aue-link>
          </div>
        </div>
      </div>


    <div class="mobile-complete-scrollbar-wrapper">
          <!-- mobile scroll buttons -->
      <div class="sidebar-buttons-wrapper-mobile is-hidden-tablet">
          <!-- your selections button mobile-->
          <div class="is-hidden-tablet sidebar-buttons-mobile">
                  <button mat-flat-button class="secondary" (click)="handleMobileSelectionsButtonClick()">
                    <span>YOUR SELECTIONS </span>
                    <mat-icon
                      *ngIf="!showMobileSelections"
                      class="filter-button-icon"
                      inline=true
                      fontSet="fas"
                      fontIcon="fa-chevron-down"
                      ></mat-icon>
                    <mat-icon
                      *ngIf="showMobileSelections"
                      class="filter-button-icon"
                      inline=true
                      fontSet="fas"
                      fontIcon="fa-chevron-up"
                      ></mat-icon>
                  </button>
          </div>
                    <!-- mobile filter button and messages -->
          <div class="is-hidden-tablet sidebar-buttons-mobile">
                      <div class="columns is-multiline is-mobile is-gapless is-vcentered">
                        <div class="column filters-button-container">
                          <button mat-flat-button class="secondary" (click)="handleMobileFiltersButtonClick()">
                            <span>{{filtersTitle}} ({{selectedFiltersCount}}) </span>
                            <mat-icon
                              *ngIf="!showMobileFilters"
                              class="filter-button-icon"
                              inline=true
                              fontSet="fas"
                              fontIcon="fa-chevron-down"
                              ></mat-icon>
                            <mat-icon
                              *ngIf="showMobileFilters"
                              class="filter-button-icon"
                              inline=true
                              fontSet="fas"
                              fontIcon="fa-chevron-up"
                              ></mat-icon>
                          </button>
                        </div>
                      </div>
          </div>
          <!-- share results button mobile-->
          <!-- <div class="is-hidden-tablet sidebar-buttons-mobile">
          <button *ngIf="showShareResultsButton" mat-flat-button class="primary" (click)="handleShareResultsClick()">{{shareResultsButtonText}}</button>
          </div> -->
          <div class="is-hidden-tablet sidebar-buttons-mobile" *ngIf="showSaveResultsButton">
            <button mat-flat-button class="primary header-share-results-button" (click)="handleShowSaveResultsClick()">SAVE RESULTS</button>
          </div>
          <!-- start over button mobile-->
          <div class="is-hidden-tablet sidebar-buttons-mobile start-over">
            <button mat-flat-button class="secondary" (click)="handleStartOverClick()">{{startOverButtonText}}</button>
          </div>
      </div>

          <!-- mobile expand info area -->
      <div class="mobile-expand-info is-hidden-tablet">
        <!-- mobile sorting & filters -->
        <div *ngIf="!resultsLoading" class="is-hidden-tablet">
              <div class="columns is-multiline is-mobile is-gapless mobile-filters-section-container" [ngClass]="{ 'visible-mobile' : showMobileFilters }">
                <!-- price sorting -->
                <label class="column is-full-mobile info-header mobile">{{priceSortMobileTitle}}</label>
                <div *ngIf="showPriceSort" class="column is-full-mobile">
                  <app-price-sorting [ammountResultsShown]="amountOfResultsCurrentlyShown" [totalResults]="totalQuantityResults" (changePriceSorting)="handlePriceSorting($event)"></app-price-sorting>
                </div>
                <div class="buffer-medium"></div>
                <!-- checkbox filters -->
                <label class="column is-full-mobile info-header mobile">{{filtersTitle}}</label>
                <div class="column is-half-mobile">
 
                  <app-availability-filters (availabilityToFilterBy)="handleAvailabilityFilter($event)"></app-availability-filters>
                  <div class="spacer-small"></div>
                  <app-chromebook-plus-filters (ChromebookPlusToFilterBy)="handleChromebookPlusFilter($event)"></app-chromebook-plus-filters>
                  <div class="spacer-small"></div>
                  <app-form-factors-filters (formFactorsToFilterBy)="handleFormFactorFilter($event)"></app-form-factors-filters>
                  <div class="spacer-small"></div>
                  <app-brand-filters (brandsToFilterBy)="handleBrandsFilter($event)" (setInitialSelectedBrands)="setInitialSelectedBrands($event)"></app-brand-filters>
                </div>
                <div class="column is-half-mobile">
                  <app-screen-size-filters (screenSizesToFilterBy)="handleScreenSizeFilter($event)"></app-screen-size-filters>
                  <div class="spacer-small"></div>
                  <app-feature-filters (featuresToFilterBy)="handleFeatureFilter($event)"></app-feature-filters>
                  <div class="spacer-small"></div>
                  <app-os-type-filters [isEnterpriseWorkflow]="isEnterprisePrimaryUse" (osTypesToFilterBy)="handleOsTypeFilter($event)" (setInitialSelectedOsTypes)="setInitialSelectedOsTypes($event)"></app-os-type-filters>
                </div>
                <!-- AUE link mobile -->
                <div class="column is-full-mobile" *ngIf="showAUELink">
                  <app-aue-link></app-aue-link>
                </div>
              </div>
        </div>
        <!-- your selections info mobile -->
        <div class="is-hidden-tablet">
            <div class="columns is-multiline is-mobile is-gapless mobile-filters-section-container" [ngClass]="{ 'visible-mobile' : showMobileSelections }">
              <app-selections [showTitle]="false"></app-selections>
              <!-- AUE link mobile -->
              <div class="column is-full-mobile" *ngIf="showAUELink">
                <app-aue-link></app-aue-link>
              </div>
            </div>
        </div>
      </div>

    </div>

    <div class="column top-wrapper">
      <div *ngIf="showNoResultsMessage">
        <label class="mobile-results-message">{{noResultsMessage}}</label>
      </div>
      <div class="is-hidden-tablet" *ngIf="!resultsLoading">
        <h2 class="results-label-h2 top-results-label">Your Top {{numberOfDevicesPerLoad}} Results</h2>
        <div class="price-sort-button">
          1 - {{amountOfResultsCurrentlyShown}} of {{totalQuantityResults}} Results
        </div>
        <!-- <label class="mobile-results-message">{{topNumberOfItemsMessageMobile}}</label> -->
      </div>
    </div>

    </div>
    <!-- <div class="buffer-medium is-hidden-tablet"></div> -->
    <div class="column is-hidden-mobile is-narrow"><div class="buffer-column-container"></div></div>
    <!-- chromebooks list -->
    <div class="column is-12-mobile results-info-wrapper">
      <div *ngIf="!resultsLoading && compareIsVisible" class="compare-results is-hidden-mobile">
        <app-compare-results (onRemoveCompareItem)="handleUpdatingCompareDevices($event)" class="compare-results-section" [compareResultsList]="compareDeviceGroups"></app-compare-results>
      </div>
      <div *ngIf="!resultsLoading" class="filter is-hidden-mobile">
        <h2 class="results-label-h2 top-results-label">Your Top {{numberOfDevicesPerLoad}} Results</h2>
        <app-filter-chips
          [isEnterpriseWorkflow]="isEnterprisePrimaryUse"
          [formFactorFilters]="filterItemsFromCheckboxParams.formFactors"
          [screenSizeFilters]="filterItemsFromCheckboxParams.screenSizes"
          [brandFilters]="filterItemsFromCheckboxParams.brands"
          [featureFilters]="filterItemsFromCheckboxParams.features"
          [osTypeFilters]="filterItemsFromCheckboxParams.osTypes"
          [availabilityFilters]="filterItemsFromCheckboxParams.availability"
          [chromebookPlusFilters]="filterItemsFromCheckboxParams.chromebookPlus"
          (updateFormFactorFilter)="formFactorFilters.onFormFactorChange($event)"
          (updateScreenSizeFilter)="screenSizeFilters.onScreenSizeFilterChange($event)"
          (updateBrandFilter)="brandFilters.onBrandFilterChange($event, true)"
          (updateFeatureFilter)="featureFilters.onFeatureChange($event)"
          (updateOsTypeFilter)="osTypeFilters.onOsTypeChange($event)"
          (updateAvailabilityFilter)="availabilityFilters.onAvailabilityChange($event)"
          (updateChromebookPlusFilters)="chromebookPlusFilters.onChromebookPlusChange($event)"
        ></app-filter-chips>
        <app-price-sorting *ngIf="showPriceSort" [ammountResultsShown]="amountOfResultsCurrentlyShown" [totalResults]="totalQuantityResults"  (changePriceSorting)="handlePriceSorting($event)"></app-price-sorting>
      </div>
      <div *ngIf="resultsLoading" class="spinner-container">
        <mat-spinner diameter="75" aria-label="Loading indicator for results being retrieved."></mat-spinner>
        <div class="buffer-small"></div>
      </div>
      <div class="is-hidden-mobile">
        <div *ngIf="showNoResultsMessage">
          <h1 class="results-msg no-matching-results-msg">{{noResultsMessage}}</h1>
        </div>
      </div>
      <div *ngFor="let group of displayedDeviceGroups">
        <app-device-result [checkboxesAreDisabled]="checkboxesAreDisabled" (onCompareDeviceAddedOrRemove)="handleUpdatingCompareDevices($event)" [group]="group"></app-device-result>
      </div>
      <div *ngIf="!resultsLoading" class="price-sort-button">
        1 - {{amountOfResultsCurrentlyShown}} of {{totalQuantityResults}} Results
      </div>
      <div *ngIf="enableLoadMore" class="load-more-button-container">
        <button mat-flat-button class="primary" (click)="loadMoreDevices()">{{loadMoreButtonText}}</button>
      </div>
    </div>
  </div>
</div>
<!-- <span class="is-hidden-tablet">
  <div class="mobile-navigation-container" [ngClass]="{ 'non-english' : isNonEnglishLocale }">
    <button mat-flat-button class="secondary" (click)="handleStartOverClick()">{{startOverButtonText}}</button>
    <div *ngIf="showShareResultsButton">
      <button mat-flat-button class="primary" (click)="handleShareResultsClick()">{{shareResultsButtonText}}</button>
    </div>
  </div>
</span> -->
<form *ngIf="marketoFormId !== ''" [attr.id]="'mktoForm_' + marketoFormId" style="display:none"></form>
